import { type CustomTooltipProps } from "ag-grid-react"

import HeaderTooltip from "./HeaderTooltip"
import { SuggestedOrdersCard } from "~/components/purchaseOrder/PurchaseOrdersForSkus"
import { type IVariantSummary } from "~/hooks/useVariantTableData"

const SuggestedOrderTooltip = (
  props: CustomTooltipProps<
    IVariantSummary,
    {
      isInThePast: boolean
      suggestedOrders: { quantity: number; warehouseId: string }[]
      skuIds: string[]
      lifecycleStatus: string
      isFashion: boolean
      minOrderDate?: Date
      buyCount?: number
      isTotalsRow?: boolean
      /** The cell shows cost; says the listed quantities are units. */
      inUnits?: boolean
    }
  >,
) => {
  if (props.location === "header") {
    return <HeaderTooltip {...props} />
  }

  if (props.location === "cell") {
    const buyCount = props.value?.buyCount ?? 1
    const hasOrders = (props.value?.suggestedOrders?.length ?? 0) > 0

    if (!hasOrders) return null

    const headerNotes = [
      props.value?.isTotalsRow ? `Across ${buyCount} ${buyCount === 1 ? "buy" : "buys"}` : null,
      props.value?.inUnits ? "In units" : null,
    ].filter(Boolean)
    const headerRight =
      headerNotes.length > 0 ? (
        <span className="text-fg-subtle text-xs">{headerNotes.join(" · ")}</span>
      ) : undefined

    return (
      <div className="flex flex-col gap-1">
        {!props.value?.isTotalsRow && buyCount > 1 && (
          <p className="text-fg-subtle text-xs">Across {buyCount} buys</p>
        )}
        <SuggestedOrdersCard
          suggestedOrders={props.value?.suggestedOrders ?? []}
          skuIds={props.value?.skuIds ?? []}
          lifecycleStatus={props.value?.lifecycleStatus}
          isFashion={props.value?.isFashion}
          isInThePast={props.value?.isInThePast}
          headerRight={headerRight}
        />
      </div>
    )
  }
}

export default SuggestedOrderTooltip
